export let Code = {
type: `@Component({
    selector: 'p-inputSwitch',
    template:
        <p-inputSwitch [(ngModel)]="checked1"></p-inputSwitch>
})
export class Switch {

}
`,
typeLabel: `@Component({
    selector: 'p-inputSwitch',
    template:
        <p-inputSwitch onLabel="Yes" offLabel="No" [(ngModel)]="checked2"></p-inputSwitch>
})
export class SwitchClick {

}
`
};


// WEBPACK FOOTER //
// ./src/app/code/switch.ts